import { SendAs, Merchant, Reward, File } from './index';

export enum Shapes {
  square = 'square',
  circle = 'circle',
  rounded = 'rounded',
}

export enum CardType {
  point = 'point',
  stamp = 'stamp',
  openEndedPoint = 'openEndedPoint',
}

export interface StampCardPromo {
  active?: boolean;
  originalStamps?: Number;
  newStamps?: Number;
  end?: Date;
  timezone?: string;
}

export interface EarningMethod {
  _id?: string;
  title: string;
  description: string;
  pointsAwarded?: number;
}

export interface PostAcquisitionPopup {
  enabled: boolean;
  icon?: {
    mobile: string;
    web: string;
    filled: boolean;
  };
  title?: string;
  description?: string;
  actionButton?: {
    title?: string;
    actionType?: 'url' | 'vouchers' | 'close';
    url?: string;
  };
}

export interface Colors {
  text: string;
  card: string;
  stampFill: string;
  stampFillEmpty: string;
  stampOutline: string;
  icons: string;
  qrCode: string;
  cardGradient?: {
    from: string;
    to: string;
    value: number;
    angle: number;
  };
  progressBar: string;
  progressBarBg: string;
}

export interface Icons {
  opacity: number;
  stamp: {
    mobile: string;
    web: string;
    filled: boolean;
  };
  reward: {
    mobile: string;
    web: string;
    filled: boolean;
  };
}

export interface RewardIcon {
  stamp?: number;
  mobile?: string;
  web?: string;
  filled?: boolean;
  image?: File;
}

export interface CardVariant {
  _id?: string;
  name: string;
  active: boolean;
  priority?: number;
  conditions: {
    emailDomains?: string[];
    emails?: string[];
    emailContains?: string[];
  };
  colors?: Colors;
  icons?: Icons;
  rewardIcons?: RewardIcon[];
  shape?: string;
  showLogo?: boolean;
  customLogo?: File;
  stampImage?: File;
  rewardImage?: File;
  backgroundImage?: File;
  backgroundImageOpacity?: number;
}

export interface StampCard {
  _id?: string;
  nanoid?: string;
  title?: string;
  description?: string;
  terms?: string;
  numberOfStamps?: number;
  joinStamps?: number;
  stampsPerScan?: number;
  merchant?: string | Merchant;
  active?: boolean;
  locations?: any[];
  ref?: number;
  colors?: Colors;
  icons?: Icons;
  rewardIcons?: RewardIcon[];
  points?: {
    totalPoints: number;
    joinPoints: number;
    maxPoints: number;
    pointsPerScan: number; //for fixed points cards, and open-ended where basis is transaction or earning method is fixed
    value: number; //basis is value, earning method incremental = points per £1 spent
    expiry: {
      active: boolean;
      days: number;
    };
    basis: string; //transaction or value
    earningMethod: string; //fixed or incremental
  };

  shape?: Shapes;
  showLogo?: boolean;
  soundOn?: boolean;
  stampImage?: File;
  rewardImage?: File;
  backgroundImage?: File;
  backgroundImageOpacity?: number;
  rewards?: [{ stamp: number; reward: Reward; points?: number }];
  earningMethods?: EarningMethod[];
  customLogo?: File;
  restrictions?: {
    connectOverride: boolean;
    daily: {
      enabled: boolean;
      value: number;
      asset: string;
    };
    interval: {
      enabled: boolean;
      value: number; //minutes
      asset: string;
    };
  };
  displayAs?: SendAs;
  stampPromo?: number;
  cardType?: CardType;
  _canManage?: boolean;
  info?: string;
  postAcquisitionPopup?: PostAcquisitionPopup;
  variants?: CardVariant[];
}
